import React from 'react';
import { Box, TextField } from '@mui/material';
import { errorNames } from '../../../../../utils/constants';
import { ErrorText } from '../../../../errorText/ErrorText';
import { borderInput } from '../../../../formAddress/formAddress.styles';
import { boxStyles, useStyles } from '../../modalEditProfile.styles';
import { IPropsControl } from '../../types';

export const DescriptionControl = (props: IPropsControl): JSX.Element => {
  const classes = useStyles();
  const { register, errors } = props;

  return (
    <Box sx={boxStyles}>
      <TextField
        rows={5}
        multiline
        error={!!errors?.description}
        fullWidth
        label="Description"
        id="org description"
        {...register('description', { maxLength: 3000 })}
        className={classes.modalInp}
        sx={borderInput}
      />
      <div className={classes.errors}>
        {errors?.description?.type === 'maxLength' && <ErrorText text={errorNames.descriptionLength} />}
      </div>
    </Box>
  );
};
